module.exports = __webpack_public_path__ + "static/media/flags.723494a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/form/native/Input/assets/flags.png
// module id = 1419
// module chunks = 0